// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"1685b59c","84":"256ffc4f","184":"a7932a35","250":"49723acb","393":"e0a0d6ac","448":"47d9e530","488":"02e52e92","510":"0600339d","579":"71d52d74","652":"84fb551d","811":"a161822e","818":"43e6b6bb","854":"666b478c"}[chunkId] + ".chunk.js";
};